import { BarChartOutlined, CarOutlined, DatabaseOutlined, DownloadOutlined, LineChartOutlined, LogoutOutlined } from '@ant-design/icons';
import { FC, ReactNode } from 'react';
import { LoginPage } from '../pages/login';
import { useAuthContext } from '../services/auth.service';
import { getversion } from '../version';
import './layout.scss';

/* -------------------------------------------------------------------------------- *\
|                               LayoutSite
\* -------------------------------------------------------------------------------- */
export const LayoutSite: FC<{ children?: ReactNode }> = (children) =>
{
	var auth = useAuthContext();
	if (!auth || !auth.token)
	{
		return <LoginPage />
	}

	return (
		<div className="layout">
			<div className="layout__sider" >
				<div className="layout__logo">
				<a href="/" ><img src={'/images/logo.png'} alt="McLloyd" /></a>
				</div> 
				<div className="layout__menucont">
					<div className="layout__menu">
						<a className='layout__menu__item' href="/import" ><DownloadOutlined /></a>
						<a className='layout__menu__item' href="/datas" ><DatabaseOutlined /></a>
						<a className='layout__menu__item' href="/simulator" ><CarOutlined /></a>
						<a className='layout__menu__item' href="/analysis" ><LineChartOutlined /></a>
						<a className='layout__menu__item' href="/delta" ><BarChartOutlined /></a>
					</div>
					<div className="layout__menu layout__menu__bottom">
						<div className='layout__menu__item' onClick={() => auth.logout()}><LogoutOutlined /></div>
					</div>
				</div>
			</div>
			<div className="layout__content">
				<div className="layout__content__inner">
					<div>{children.children}</div>
					<div className="layout__footer">{getversion()}</div>
				</div>
			</div>
	  </div>
	  );
}